export const setButtonAriaLabel = ({ openInNewTab, text = '' }: { openInNewTab?: boolean; text?: string; }) => (
  text ? `${text}${(openInNewTab === true) ? ' (opens in a new tab)' : ''}` : ''
);

export const isUrl = (input: string) => (input.startsWith('/') || input.startsWith('http')) || input.startsWith('mailto') || input.startsWith('tel');

export const addHash = (input: string) => (input.startsWith('#') ? input : `#${input}`);

export const toUrlType = (checkUrl: string) => {
  if (checkUrl) {
    return isUrl(checkUrl) ? checkUrl : addHash(checkUrl);
  }
  return '';
};
